import React, { useContext } from "react";
import Row from 'react-bootstrap/Row';
import Container from 'react-bootstrap/Container';
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import './SlideCard.css'
import Card from 'react-bootstrap/Card';
import Col from 'react-bootstrap/Col';
import ViewMoreButtonDesktop, { ViewMoreButtonMobile } from "../../WebButton/ViewMoreButton";
import { useAppContext } from "../../Context/AppContext";

const SlideCards = (props) => {
    const { children, title, url } = props;

    const responsive = {
        superLargeDesktop: {
            breakpoint: { max: 4000, min: 3000 },
            items: 3
        },
        desktop: {
            breakpoint: { max: 3000, min: 1024 },
            items: 3
        },
        tablet: {
            breakpoint: { max: 1024, min: 464 },
            items: 1
        },
        mobile: {
            breakpoint: { max: 464, min: 0 },
            items: 1
        }
    };

    const { BASE_PATH } = useContext(useAppContext);
    return (
        <section className='slidecard'>

            <Container className='card-section'>
                <Row>
                    <div className="whitetitle">
                        <h2>{title}</h2>
                        <ViewMoreButtonDesktop redirect={url} />
                    </div>
                </Row>
                <Carousel responsive={responsive} autoPlaySpeed={2000} autoPlay={true} infinite={true}>
                    {
                        children.map((list, index) => {
                            const { articleurl, categorytitle, categoryurl, date, image, title } = list;
                            return (
                                <Row key={index} className="slidecardrow p-2">

                                    <Col lg={6} md={6} sm={6} xs={6} >
                                        <img src={image} alt={title} loading="lazy" />
                                    </Col>
                                    <Col lg={6} md={6} sm={6} xs={6} className='p-2'>
                                        <p className='card-category'>{categorytitle} </p>
                                        <Card.Link href={`${BASE_PATH}${categoryurl}/${articleurl}`}>
                                            <Card.Title className='word-line-limit3' >{title}</Card.Title>
                                        </Card.Link>
                                        <Card.Text className='card-date'>
                                            {/* {cardartical.date} */}
                                        </Card.Text>
                                    </Col>

                                </Row >

                            )
                        })
                    }
                </Carousel>
                <ViewMoreButtonMobile redirect={url} />
            </Container >
        </section >
    )
}

export default SlideCards;

